<template>
    <div class="all">
        <!-- 会员导航 -->
        <vipMenu></vipMenu>
        <div class="warp mt20">
            <div class="warp-header">
                <h2>{{pageType === 'renew' ? '会员续费' : '会员购买'}}</h2>
            </div>
            <div class="warp-body clearfix">
                <!-- 建方案 -->
                <div class="form-warp input-list field fl">
                    <div class="item clearfix">
                        <span class="name fl">清贝余额:</span>
                        <div class="input-father">
                            <span class="input-tips">{{qingBeiBalance}}</span>
                        </div>
                    </div>
                    <div class="item clearfix" v-if="conversionQingBeiNum != 0">
                        <span class="name fl">会员抵扣:</span>
                        <div class="input-father">
                            <span class="input-tips">{{des}}</span>
                        </div>
                    </div>
                    <div class="item clearfix">
                        <span class="name fl">清贝描述:</span>
                        <div class="input-father">
                            <span class="input-tips">{{memberGradeName}}</span>
                        </div>
                    </div>
                    <div class="item clearfix">
                        <span class="name fl">充值服务:</span>
                        <div class="input-father">
                            <span class="input-tips">{{rechargeService}}</span>
                        </div>
                    </div>
                    <div class="item clearfix">
                        <span class="name fl">充值账号:</span>
                        <div class="input-father">
                            <span class="input-tips">{{account}}</span>
                        </div>
                    </div>
                    <div class="item clearfix">
                        <span class="name fl">充值方式:</span>
                        <div class="input-father">
                            <div class="corm clearfix">
                                <span class="element" :class="timeType === 1 ? 'curr' : ''" @click="timeSelect(0);">按月</span> 
                                <span class="element" :class="timeType === 12 ? 'curr' : ''" @click="timeSelect(1);">按年</span>
                            </div>
                        </div>
                    </div>
                    <div class="item clearfix">
                        <span class="name fl">开通时长:</span>
                        <div class="input-father duan">
                            <input class="input-text" v-model.trim="number" value="1" type="text" placeholder="" maxLength="3" @keyup="inputNumber();" />
                            {{timeType === 1 ? '月' : '年'}}
                        </div>
                    </div>
                    <div class="item clearfix">
                        <span class="name fl">优惠券:</span>
                        <div class="input-father">
                            <span class="color-blue input-tips" v-show="couponCodeSucess != ''">{{couponCodeSucess}} <a class="del" href="javascript:void(0);" @click="delCoupon();" title="删除优惠券">×</a></span><button v-show="couponCodeSucess === ''" class="btn btns" @click="addCouponModal();"><i class="icons add-icon1"></i><span class="color-blue">添加优惠券</span></button>
                        </div>
                    </div>
                    <div class="item clearfix">
                        <span class="name fl">应付金额:</span>
                        <div class="input-father duan">
                            <span class="input-tips"><strong class="color-orange fs28">{{discountPrize}}</strong> 清贝　　<s v-if="discountPrize != prize">{{prize}}清贝</s></span>
                        </div>
                    </div>
                    <div class="form-btn">
                        <button class="btn save btn-jbblue" @click="payment();">立即支付</button>
                    </div>
                </div>
                <!-- 方案预览 -->
                <div class="examine w300 fl">
                    <div class="examine-header">
                        <h4><i class="icons" :class="vipIcons[$parent.memberType-1]"></i>{{memberGradeName}}</h4>
                    </div>
                    <div class="examine-body">
                        <ul>
                            <li v-for="(item,index) in memberRights" :key="index"><strong>{{index+1}}.</strong>{{item}}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- 添加优惠券 -->
        <Dialog ref="couponModal" :callback="saveCoupon" type="confirm" title="添加优惠券">
            <div slot="mdBox">
                <p class="fs12 color-red" v-if="activityDiscountType != ''">提示：当前活动已有{{activityDiscount/10}}折折扣，多种折扣不能叠加使用，如果使用优惠券将以优惠券折扣为准！</p>
                <div class="mt10">
                    <input class="input-text" v-model.trim="couponCode" maxlength="16" id="" type="text" placeholder="请输入优惠券码"/>
                </div>
            </div>
        </Dialog>
        <!-- 充值提示 -->
        <Dialog ref="payModal" :callback="enterPay" type="confirm">
            <div slot="mdBox">
                <p v-html="paytips"></p>
            </div>
        </Dialog>
        <!-- 充值成功提示 -->
        <Dialog ref="sucessModal" type="alert">
            <div slot="mdBox">
                <p v-html="tipsHtml"></p>
            </div>
        </Dialog>
	</div>
</template>
<script>
import Dialog from '../../components/dialog.vue';
import vipMenu from './vipMenu.vue';
export default {
    components:{Dialog,vipMenu},
    data() {
        return {
            vipIcons:['rank-icon3','rank-icon1','rank-icon3','rank-icon5'],//会员等级对照表
            prize:'',//购买总价
            pageType:'',//页面类型
            discountPrize:'',//折扣价格
            memberType:'',//会员等级
            account:'',//账号
            memberGrade:'',//会员等级
            memberGradeName:'',//会员等级名称
            rechargeService:'',//会员价格明细
            memberRights:[],//会员权限列表
            qingBeiBalance:'',//清贝余额
            des:'',//会员抵扣描述
            conversionQingBeiNum:'',//会员清贝抵扣
            qingBeiNum:'',//会员单价每月
            discount:'',//折扣
            activityDiscount:'',//活动折扣
            number:1,//购买个数
            timeType:1,//按月买是1 按年买是12
            paytips:'',//充值提示语
            tipsHtml:'',//提示语
            discountType:'',//折扣类型//1是折扣 2是抵扣
            activityDiscountType:'',//活动折扣类型//1是折扣 2是抵扣
            couponCode:'',//兑换码
            couponCodeSucess:''//成功后的兑换码显示
        }
    },
    mounted() {
		let that = this;
        that.$nextTick(()=> {
            that.$sensors.track('ClickRecharge', {
                recharge_type:'会员'
            });
            that.getVipInformation();
        }) 
    },
    created() {
		
    },
    methods: {
        // 获取会员信息
        getVipInformation () {
            let that = this;
            let pageType = that.$route.query.form;
            let memberType = that.$route.query.memberType;
            that.pageType = pageType;
            let datas = {
                memberType:memberType
            };
            if(pageType === 'renew'){//续费
                datas = null;
            }
            that.$parent.loadModal(true,'正在获取数据...');
            that.$api.get('user/member/renew-info',datas,r =>{
                that.$parent.returnCode(r,function(){
                    that.$parent.showLoad = false;
                    let data = r.data;
                    that.memberType = data.memberType;
                    that.account = data.account;
                    that.memberGrade = data.memberGrade;
                    that.memberGradeName = data.memberGradeName;
                    that.rechargeService = data.rechargeService;
                    that.memberRights = data.memberRights;
                    that.qingBeiBalance = data.qingBeiBalance;
                    that.conversionQingBeiNum = data.conversionQingBeiNum;
                    that.qingBeiNum = data.qingBeiNum;
					that.activityDiscountType = data.discountType;//活动折扣类型
                    that.activityDiscount = data.discount;//活动折扣
                    that.des = data.des;
                    that.countPrize();  
                });
            })
        },
        // 计算价格
        countPrize () {
            let that = this;
            let qingBeiNum = that.qingBeiNum;//单价
            let discount = '';//折扣
            let timeType = that.timeType;//按月买是1 按年买是12
            let number = that.number;
            let discountType = '';
            if(that.discountType != ''){
                discountType = that.discountType;
                discount = that.discount;
            }else{
                discountType = that.activityDiscountType;
                discount = that.activityDiscount;
            }
            let conversionQingBeiNum = that.conversionQingBeiNum;//会员时间抵扣
            let prize = qingBeiNum*number*timeType-conversionQingBeiNum;//原本总价
            prize = prize.toFixed(2);
            let discountPrize = '';//折扣总价
            if(discountType === 1){//
                discount = discount/100;
                discountPrize = (qingBeiNum*number*timeType-conversionQingBeiNum)*discount;
            }else if(discountType === 2){
                discountPrize = qingBeiNum*number*timeType-conversionQingBeiNum-discount;
            }else if(discountType === ''){
                discountPrize = qingBeiNum*number*timeType-conversionQingBeiNum;
            }
            if(discountPrize < 0){
                discountPrize = 0;
            }
            discountPrize = discountPrize.toFixed(2);
            that.prize = prize;
            that.discountPrize = discountPrize;
        },
        // 月份年份选择
        timeSelect (type) {
            if(type === 0){//月
                this.timeType = 1;
            }else if(type === 1){//年
                this.timeType = 12;
            }
            this.countPrize();
        },
        inputNumber () {
            let that = this;
            let number = that.number;
            number = number.replace(/[^\d\.]/g, '');
            let str = number.substr(0,1);
            if(str === '0' || str === '.'){
              number = number.substr(1);
            }
            that.number = number;
            if(number != ''){
                that.number = parseInt(number);
            }
            that.countPrize();  
        },
        // 支付
        payment () {
            let that = this;
            let number = that.number;
            let discountPrize = that.discountPrize;
            let qingBeiBalance = that.qingBeiBalance;
            if(number == ''){
                that.$utils.alertText('请输入购买时长');
                return;
            }else if(qingBeiBalance - discountPrize < 0){
                that.$utils.alertText('余额不足');
                return;
            }else if(discountPrize <= 0){
                that.$utils.alertText('当前支付清贝应大于0');
                return;
            }
            that.paytips = '<p class="ac">确定购买<strong class="color-blue">'+that.memberGradeName+'</strong></p>';
            if(that.pageType === 'renew'){//续费
                that.paytips = '<p class="ac">确定续费<strong class="color-blue">'+that.memberGradeName+'</strong></p>';
            }
            that.$refs.payModal.showMaskFun();
        },
        // 确认充值
        enterPay () {
            let that = this;
            this.$sensors.track('ImmediatePay', {
                recharge_type:'会员',
                pay_number:this.discountPrize
            });
            let memberType = that.$route.query.memberType;
            let datas = {
                months:that.number*that.timeType,
                memberType:memberType,
                qingBeiNum:that.discountPrize,
                cardCode:that.couponCodeSucess
            }
            let html = '';
            html = '购买成功';
            if(that.pageType === 'renew'){//续费
                html = '续费成功';
                datas = {
                    months:that.number*that.timeType,
                    cardCode:that.couponCodeSucess,
                    qingBeiNum:that.discountPrize 
                };
            }
            that.$refs.payModal.closeMask();
            that.$parent.loadModal(true,'正在提交数据...');
            that.$api.post('user/member/recharge-member',{data:datas},r =>{
                that.$sensors.track('PayResult', {
                    recharge_type:'会员',
                    pay_number:that.discountPrize
                });
                that.$parent.returnCode(r,function(){
                    that.$parent.showLoad = false;
                    that.$utils.alertText(html);
                    that.$parent.getUserInformation();
                    window.location.reload()
                });
            })
        },
        // 添加优惠券
        addCouponModal () {
            let that = this;
            that.$refs.couponModal.showMaskFun();
        },
        // 保存优惠券
        saveCoupon () {
            let that = this;
            if(that.couponCode == '' || that.couponCode.length != 16){
                that.$utils.alertText('请输入正确的16位优惠券码');
                return;
            }
            let data = {cardCode:that.couponCode,memberType:that.$route.query.memberType};
            that.$parent.loadModal(true,'正在提交数据...');
            that.$api.get('user/member/get-concessional-amount',data,r =>{
                that.$parent.returnCode(r,function(){
                    that.$parent.showLoad = false;
                    that.discountType = r.data.discountType;//1是折扣 2是抵扣
                    that.discount = r.data.discount;
                    that.countPrize();
                    that.$refs.couponModal.closeMask();
                    that.$utils.alertText('添加成功');
                    that.couponCodeSucess = that.couponCode;
                    that.couponCode = '';
                });
            })
        },
        // 删除优惠券
        delCoupon () {
            this.couponCodeSucess = '';
            this.discountType = '';
            this.discount = '';
            this.countPrize();
        }
	}
}
</script>



// WEBPACK FOOTER //
// src/page/personalCenter/renew.vue